import { render, staticRenderFns } from "./FancyFormatting.vue?vue&type=template&id=24a14668&"
import script from "./FancyFormatting.vue?vue&type=script&lang=js&"
export * from "./FancyFormatting.vue?vue&type=script&lang=js&"
import style0 from "./FancyFormatting.vue?vue&type=style&index=0&id=24a14668&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports